import { render, staticRenderFns } from "./AcceptTerms.vue?vue&type=template&id=1028abc7&scoped=true"
import script from "./AcceptTerms.vue?vue&type=script&lang=js"
export * from "./AcceptTerms.vue?vue&type=script&lang=js"
import style0 from "./AcceptTerms.vue?vue&type=style&index=0&id=1028abc7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1028abc7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1028abc7')) {
      api.createRecord('1028abc7', component.options)
    } else {
      api.reload('1028abc7', component.options)
    }
    module.hot.accept("./AcceptTerms.vue?vue&type=template&id=1028abc7&scoped=true", function () {
      api.rerender('1028abc7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/default/AcceptTerms.vue"
export default component.exports